/** The browser needs the VAPID server public key as an array of Unsigned 8-bit integers (UInt8Array),
 * but we have it stored in Base64, this does the conversion */
export const urlB64ToUint8Array = (base64String: string): Uint8Array => {
	const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
	const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

	const rawData = atob(base64);
	const outputArray = new Uint8Array(rawData.length);

	for (let i = 0; i < rawData.length; ++i) {
		outputArray[i] = rawData.charCodeAt(i);
	}
	return outputArray;
};

const serviceWorkerPath = import.meta.env.DEV
	? '/src/common/notifications/service-worker.js'
	: '/service-worker.js';

const serviceWorkerType = import.meta.env.DEV ? 'module' : 'classic';

export class WebAppServiceWorker {
	private _vapidDetails: Promise<PushSubscription> | null = null;

	constructor() {}

	/** Register the service worker and return the service worker registration- it is safe to call this as often as
	 * required, if already registered it will just return the current registration */
	public async register(): Promise<ServiceWorkerRegistration> {
		if (!('serviceWorker' in navigator))
			throw new Error('Browser does not support service workers');
		const serviceWorkerRegistration = await navigator.serviceWorker.register(serviceWorkerPath, {
			type: serviceWorkerType,
		});
		return serviceWorkerRegistration;
	}

	/** Get the current VAPID Details object for this browser client */
	public async vapidDetails() {
		if (this._vapidDetails) return this._vapidDetails;
		const serviceWorkerRegistration = await this.register();
		this._vapidDetails = serviceWorkerRegistration.pushManager.subscribe({
			userVisibleOnly: true,
			applicationServerKey: urlB64ToUint8Array(import.meta.env.VITE_VAPID_PUBLIC_KEY),
		});
		return this._vapidDetails;
	}

	/** Unsubscribe all current notification registrations */
	public async unsubscribeAll() {
		const serviceWorkerRegistration = await this.register();
		serviceWorkerRegistration.pushManager.getSubscription().then(function (subscription) {
			subscription?.unsubscribe();
		});
	}
}

export const getNotificationPermission = async (): Promise<boolean> => {
	if (Notification.permission === 'denied' || Notification.permission === 'default')
		await Notification.requestPermission();

	return Notification.permission === 'granted';
};

export const pushNotificationsWereDenied = (): boolean => Notification.permission === 'denied';
export const pushNotificationsWereGranted = (): boolean => Notification.permission === 'granted';

export const pushNotificationsAreSupported = (): boolean => 'PushManager' in window;
